module.exports = __webpack_public_path__ + "img/wizard-tsort-3.9c29fa1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/setting-wizard/wizard-tsort-3.svg
// module id = dZDe
// module chunks = 1